module.exports = __webpack_public_path__ + "fonts/helvetica-neue-lt-pro-medium.b9c4b6f3.ttf";